import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageSymmetryBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 95.262,
	height: 89,
	viewBox: "0 0 95.262 89",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1, 0, 0, 1, -9, -0.5)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21.226,77.791C36.6,75.99,28.2,54.113,28.2,42.746c0-7.151,3.979-12.131,3.979-21.927,0-9.352-4.316-20.136-13.158-20.777C6.81-.845,0,12.656,0,25.858c0,7.977,5.412,21.265,6.63,26.7C8.342,60.2,9.252,79.194,21.226,77.791Z",
				transform: "translate(9 7.65)",
				fill: "#28666c"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.306,5.973A7.493,7.493,0,0,0,3.464,3.216,15.1,15.1,0,0,0,4.873,0,4.986,4.986,0,0,0,.132,6.123.666.666,0,0,1,.306,5.973Z",
			transform: "translate(15.386 69.143)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.59,1.583C5.479,3.089,4.305,4.043,2.52,4.1A6.013,6.013,0,0,1,0,3.647,4.977,4.977,0,0,0,3.879,5.5,4.989,4.989,0,0,0,8.868.512,5.025,5.025,0,0,0,8.839,0C8.666,0,7.727.043,6.59,1.583Z",
			transform: "translate(16.496 73.616)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.905,4.369c2.948-.09,3.748-2.392,4.819-3.216A3.015,3.015,0,0,1,9.508.44C9.483.294,9.454.148,9.417.007a3.915,3.915,0,0,0-2.38.585C5.906,1.41,5.492,2.2,3.826,2.94A6.5,6.5,0,0,1,0,3.231a4.987,4.987,0,0,0,.311.608A6.236,6.236,0,0,0,2.905,4.369Z",
			transform: "translate(15.782 72.848)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.008,6.2c.258.515,2.036-.048,2.8-.522C3.889,5.008,5,3.531,6.28,3.183a5.445,5.445,0,0,1,1.536-.191A4.99,4.99,0,0,0,3.572,0,15.552,15.552,0,0,1,2.4,3.164C1.375,5.3-.126,5.934.008,6.2Z",
			transform: "translate(17.136 69.152)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1, 0, 0, 1, -9, -0.5)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.956,77.791c-15.378-1.8-6.978-23.677-6.978-35.045C3.978,35.595,0,30.615,0,20.819,0,11.466,4.316.683,13.157.041,25.371-.845,32.183,12.656,32.183,25.858c0,7.977-5.414,21.265-6.631,26.7C23.839,60.2,22.929,79.194,10.956,77.791Z",
				transform: "translate(54.08 7.65)",
				fill: "#28666c"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.306,5.973A7.493,7.493,0,0,0,3.464,3.216,15.1,15.1,0,0,0,4.873,0,4.986,4.986,0,0,0,.132,6.123.666.666,0,0,1,.306,5.973Z",
			transform: "translate(52.023 69.143)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.59,1.583C5.479,3.089,4.305,4.043,2.52,4.1A6.013,6.013,0,0,1,0,3.647,4.977,4.977,0,0,0,3.879,5.5,4.989,4.989,0,0,0,8.868.512,5.025,5.025,0,0,0,8.839,0C8.666,0,7.727.043,6.59,1.583Z",
			transform: "translate(53.133 73.616)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.905,4.369c2.948-.09,3.748-2.392,4.819-3.216A3.015,3.015,0,0,1,9.508.44C9.483.294,9.454.148,9.417.007a3.915,3.915,0,0,0-2.38.585C5.906,1.41,5.492,2.2,3.826,2.94A6.5,6.5,0,0,1,0,3.231a4.987,4.987,0,0,0,.311.608A6.236,6.236,0,0,0,2.905,4.369Z",
			transform: "translate(52.419 72.848)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.008,6.2c.258.515,2.036-.048,2.8-.522C3.889,5.008,5,3.531,6.28,3.183a5.445,5.445,0,0,1,1.536-.191A4.99,4.99,0,0,0,3.572,0,15.552,15.552,0,0,1,2.4,3.164C1.375,5.3-.126,5.934.008,6.2Z",
			transform: "translate(53.773 69.152)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("line", {
			y2: 82,
			transform: "translate(38.992)",
			fill: "none",
			stroke: "#707070",
			strokeLinecap: "round",
			strokeWidth: 1,
			strokeDasharray: "1 2"
		})
	] })]
});
const ForwardRef = forwardRef(SvgAverageSymmetryBackground);
export { ForwardRef as ReactComponent };
